import Swiper from "swiper";

function initProjectQueryResults(){
	let $projectQuerySliders = $('.js-project-query-results-slider');

	if(!$projectQuerySliders.length) {
		return;
	}

	$projectQuerySliders.each(function(index) {
		let $this = $(this);
		let parentWrapper = $this.parents('.project-query-results__wrapper');
		let slidesToShow = $(this).data('slides-shown');
		parentWrapper.find('.project-query-results__navigation').addClass('project-query-results__navigation-' + index);
		parentWrapper.find('.project-query-results__counter').addClass('project-query-results__counter-' + index);
		$this.addClass('project-query-results-' + index);

		let pqrSliderList = [];
		let $counterContainer = $(`.project-query-results__counter-${index}`);

		let pqrSlider = new Swiper('.project-query-results-' + index, {
			slidesPerView: slidesToShow,
			speed: 400,
			spaceBetween: 20,
			centeredSlides: false,
			loop: false,
			simulateTouch: true,

			navigation:  {
				nextEl: `.project-query-results__navigation-${index} .swiper-button-next`,
				prevEl: `.project-query-results__navigation-${index} .swiper-button-prev`
			},

			on: {
				init: function (swiper) {
					$counterContainer.text(`${swiper.activeIndex + 1}/${swiper.slides.length}`)
				},
				slideChange: function (swiper) {
					$counterContainer.text(`${swiper.activeIndex + 1}/${swiper.slides.length}`);
				}
			}
		});

		pqrSliderList.push(pqrSlider);
		pqrSlider.init();
	});
}

export function init() {
	initProjectQueryResults();
}
